// api/index.ts

import { ApiEndpoints } from "@shared/api/api-endpoints";
import { onboardingApiClient } from "@shared/api/clients/apiClientFactory";
import {
  TenantDetailResponse,
  UpdateTenantRequest,
  ChoicesResponse,
  DepartmentResponse,
  UserInfoResponse,
  UpdateUserRequest,
  InviteUserRequestItem,
} from "./types";

export const organizationSetupApi = {
  getTenantDetail: async (tenantId: string): Promise<TenantDetailResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "tenant-detail",
      (query) => {
        query.push("tenant_id", tenantId);
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  updateTenantDetail: async (
    data: UpdateTenantRequest,
    tenantId: string
  ): Promise<TenantDetailResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "tenant",
      (query) => {
        query.push("id", tenantId);
      }
    );
    const response = await onboardingApiClient.put(url, data);
    return response.data;
  },

  getDateFormats: async (): Promise<ChoicesResponse> => {
    const url = ApiEndpoints.createUrl("auth", "choices/date_formats");
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  getCurrencies: async (): Promise<ChoicesResponse> => {
    const url = ApiEndpoints.createUrl("auth", "choices/currency");
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  getTimezones: async (): Promise<ChoicesResponse> => {
    const url = ApiEndpoints.createUrl("auth", "choices/timezone");
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  getDepartments: async (
    remoteUtilityId: string
  ): Promise<DepartmentResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/department_json",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  getUsers: async (
    tenantId: string,
    page: number = 1,
    limit: number = 50
  ): Promise<UserInfoResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "user-info",
      (query) => {
        query.push("remote_tenant_id", tenantId);
        query.push("page", page.toString());
        query.push("limit", limit.toString());
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  inviteUser: async (data: InviteUserRequestItem): Promise<any> => {
    const url = ApiEndpoints.createUrl("auth", "user-info");
    const response = await onboardingApiClient.post(url, data);
    return response.data;
  },

  updateUser: async (
    userId: number,
    userData: UpdateUserRequest,
    tenantId: string
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      `user-info/${userId}`,
      (query) => {
        query.push("remote_tenant_id", tenantId);
      }
    );
    const response = await onboardingApiClient.patch(url, userData);
    return response.data;
  },

  updateUserName: async (userId: number, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("auth", `update-username/${userId}`);
    const response = await onboardingApiClient.put(url, payload);
    return response.data;
  },

  toggleUser: async (userId: number, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("auth", `user-info/${userId}`);
    const response = await onboardingApiClient.put(url, payload);
    return response.data;
  },

  deleteUser: async (userId: number): Promise<any> => {
    const url = ApiEndpoints.createUrlWithPathVariables(
      "auth",
      `system-admin/${userId}/delete`
    );
    const response = await onboardingApiClient.put(url);
    return response.data;
  },
};
